/**
 * The 52-week position as a 0–100 score, or null when the year has no range to place it in (a
 * bound missing, or a high that is not above the low). Clamped: a close printed outside a stale
 * low or high still lands on the scale's end rather than off the track.
 *
 * Draws the 52-week tracks (`YearRangeTrack`). It is not the market mood, which is mm-be's own
 * composite score (`mood.ts`).
 */
export const yearRangeScore = (current: number, low: number, high: number): number | null => {
  if (![current, low, high].every(Number.isFinite) || high <= low) return null
  return Math.min(100, Math.max(0, ((current - low) / (high - low)) * 100))
}
